document.addEventListener('DOMContentLoaded', () => {
    // Required elements
    const clearAllElem = document.querySelector('#resources-clear-all');
    const formElem = document.querySelector('#resources-filters-form');

    // Early exit if required elements are missing
    if (!formElem || !clearAllElem) return;

    const inputElems = formElem.querySelectorAll('input[type="checkbox"]');

    /**
     * Handles the "Clear all" button click:
     */
    clearAllElem.addEventListener('click', (event) => {
        event.preventDefault();
        inputElems.forEach(inputElem => {
            inputElem.checked = false;
        });
        updateClearAllButtonLabel();
        formElem.submit();
    });

    /**
     * Gets the count of checked checkboxes in the form
     * @returns {number} The count of checked checkboxes in the form
     */
    const getCheckedCount = () => {
        return formElem.querySelectorAll('input[type="checkbox"]:checked').length;
    }

    /**
     * Updates the "Clear all" button label based on how many filters are currently checked
     */
    const updateClearAllButtonLabel = () => {
        const checkedCount = getCheckedCount();
        clearAllElem.dataset.filterCount = checkedCount;

        clearAllElem.textContent = checkedCount > 0
            ? `Clear all (${checkedCount})`
            : 'Clear all';
    };

    /**
     * Debounce utility to delay execution
     */
    const debounce = (fn, delay) => {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => fn(...args), delay);
        };
    };

    const debouncedSubmit = debounce(() => {
        formElem.submit();
    }, 1500);

    /**
     * Handle checkbox changes:
     * - Update the filter count and button label
     * - Debounced form submission
     */
    inputElems.forEach(inputElem => {
        inputElem.addEventListener('change', () => {
            updateClearAllButtonLabel();
            debouncedSubmit();
        });
    });

    /**
     * Submit the form when the duration range input changes
     */
    const durationInput = document.querySelector('#duration');
    if (durationInput) {
        durationInput.addEventListener('change', () => {
            debouncedSubmit();
        });
    }

    // Update a hidden input within the form when the sort dropdown changes
    const sortVisibleInput = document.querySelector('#sort_visible_input');
    const sortHiddenInput = document.querySelector('#sort_hidden_input');
    if (sortVisibleInput && sortHiddenInput) {
        sortVisibleInput.addEventListener('change', () => {
            const sortValue = sortVisibleInput.value;
            sortHiddenInput.value = sortValue;
            debouncedSubmit();
        });
    }

    // Initial label update on page load (e.g., if some filters are pre-selected)
    updateClearAllButtonLabel();
});
